export default class CookieActionInterface {
    constructor(func = function () {}) {
        this.func = func;
    }

    action() {
        this.func();
    }
}